import React from 'react'
import { ModalTitle } from 'react-bootstrap'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const CustomModal = ({ isOpen, toggle, children, title, isTitle = true, size = 'md' }) => {
  return (
    <Modal size={size} isOpen={isOpen} toggle={toggle} centered>
      {isTitle && (
        <ModalHeader toggle={toggle}>
          <ModalTitle className="fw-bold">{title}</ModalTitle>
        </ModalHeader>
      )}
      <ModalBody>{children}</ModalBody>
    </Modal>
  )
}

export default CustomModal
